import { render, staticRenderFns } from "./AsiaVhisProposalActions.vue?vue&type=template&id=7840d421"
import script from "./AsiaVhisProposalActions.vue?vue&type=script&lang=js"
export * from "./AsiaVhisProposalActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports